'use client'
import { selectStyles, selectLabelStyles } from '@/components/Form/Form.style'
import { SelectProps } from '@/components/Form/Form.type'

const Select = ({
  id,
  name,
  label,
  options,
  onChange,
  selectedValue,
  hidden = false,
  size = 'md',
  center = true
}: SelectProps) => (
  <div className="mx-auto flex w-full flex-col">
    {label && !hidden && (
      <label htmlFor="customSelect" className={selectLabelStyles({ size, center })}>
        {label}
      </label>
    )}
    <select
      id={id || name}
      name={name}
      value={selectedValue}
      onChange={onChange}
      className={selectStyles({ size, hidden })}
    >
      <option value="" disabled>
        Escolha uma opção
      </option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
)

export default Select
